export default __webpack_public_path__ + "static/media/celery.da6c3061.svg";